<template>
  <div>
    <!-- FILTROS -->
    <div class="card">
      <div class="card-header">
        <h5 class="card-title" id="accordion">Filtrar processos</h5>
      </div>
      <div>
        <div class="card-body">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label for="processo_numero">Número do processo</label>
                <input @keyup="buscarprocessos" class="form-control" id="processo_numero" v-model="processo_numero" />
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label for="processo_referencia">Núm. Referência</label>
                <input class="form-control" @keyup="buscarprocessos" id="processo_referencia" v-model="processo_referencia" />
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label for="processo_exequente">Exequente</label>
                <input class="form-control" @keyup="buscarprocessos" id="processo_exequente" v-model="processo_exequente" />
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label for="processo_executado">Executado</label>
                <input class="form-control" @keyup="buscarprocessos" id="processo_executado" v-model="processo_executado" />
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label for="processo_comitente">Comitente</label>
                <input class="form-control" @keyup="buscarprocessos" id="processo_comitente" v-model="processo_comitente" />
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label for="processo_vara">Vara</label>
                <input class="form-control" @keyup="buscarprocessos" id="processo_vara" v-model="processo_vara" />
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label for="processo_classe">Classe processual</label>
                <input class="form-control" @keyup="buscarprocessos" id="processo_classe" v-model="processo_classe" />
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label for="endereco_estado">UF</label>

                <select class="custom-select rounded-0" id="endereco_estado" v-model="estado" @change="buscarprocessos()">
                  <option value=""></option>
                  <option v-for="estado in estados" :key="estado" :value="estado">
                    {{ estado.nome }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label for="cidade">Cidade</label>
                <input class="form-control" @keyup="buscarprocessos" id="cidade" v-model="cidade" />
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label for="processo_local">Local do leilão</label>
                <input class="form-control" @keyup="buscarprocessos" id="processo_local" v-model="processo_local" />
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label for="processo_juiz">Nome do juiz</label>
                <input class="form-control" @keyup="buscarprocessos" id="processo_juiz" v-model="processo_juiz" />
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <label for="processo_depositario">Depositário público</label>
                <input class="form-control" @keyup="buscarprocessos" id="processo_depositario" v-model="processo_depositario" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- TABELA DE PROCESSO-->
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">Processos</h3>
        <div class="card-tools">
          <!-- PAGINAÇÃO  -->
          <ul class="pagination pagination-sm m-0 float-right">
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

            <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
              <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
                {{ pagina }}
              </a>
            </li>

            <li class="page-item">
              <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
            </li>
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
          </ul>
        </div>
      </div>
      <div class="card-body table-responsive p-0">
        <table class="table table-hover">
          <thead>
            <tr>
              <th>Seq</th>
              <th>Id</th>
              <th>Informações</th>
              <th>Editar</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(processo, index) in processos" :key="processo">
              <td data-label="Seq">{{ index + 1 }}</td>
              <td data-label="Id">{{ processo.id }}</td>

              <td data-label="Contato" style="text-transform: uppercase">
                {{ processo.processo_numero }}
                <br />
                <strong>Exequente:</strong>
                {{ processo.processo_exequente }}
                <br />
                <strong>Executado:</strong>
                {{ processo.processo_executado }}
              </td>

              <td>
                <a :href="getUrlEdit(processo)" type="button" class="btn btn-primary btn-sm">Editar</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer clearfix">
        <!-- TOTAIS  -->
        <div style="font-size: 13px" class="float-left" aria-live="polite">
          Exibindo do {{ inicio + 1 }} ao {{ inicio + processos.length }}
          <p>Total {{ total }}</p>
        </div>

        <p class="card-title" style="font-size: 12px; color: black; margin-right: 5px; margin-left: 10px">Por página</p>

        <select @change="alterarQtdPagina()" class="float-left card-titlecustom-select rounded-0" style="font-size: 12px" v-model="qtd_por_pagina">
          <option :value="25">25</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
          <option :value="200">200</option>
        </select>

        <div class="card-tools">
          <div class="input-group input-group-sm" style="width: 150px"></div>
        </div>

        <!-- PAGINAÇÃO  -->
        <ul class="pagination pagination-sm m-0 float-right">
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

          <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
            <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
              {{ pagina }}
            </a>
          </li>

          <li class="page-item">
            <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
          </li>
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  props: ["estados"],

  mixins: [sweetAlert, Swal, AuxController],

  components: [Loading],

  data() {
    return {
      isLoading: false,
      processo_selecionado: "",
      filtro: "",
      paginas: [],
      total: 0,
      inicio: 0,
      qtd_por_pagina: 25,
      pagina_atual: 1,
      processos: [],
      processo_numero: "",
      processo_vara: "",
      processo_classe: "",
      processo_comitente: "",
      processo_executado: "",
      processo_exequente: "",
      processo_referencia: "",
      processo_numero: "",
      processo_local: "",
      processo_juiz: "",
      processo_depositario: "",
      estado: "",
      cidade: "",
      max_page: 0,
    };
  },

  mounted() {
    console.log(this.docs_tipo_usuario);

    this.buscarprocessos();
  },

  methods: {
    getUrlEdit(processo) {
      return "/admin/processo/" + processo.id;
    },

    show(processo) {
      this.processo_selecionado = processo;
    },

    selecionarPagina(pagina) {
      if (pagina <= this.paginas[this.paginas.length - 1] && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscarprocessos();
      } else if (pagina == this.max_page && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscarprocessos();
      }
    },

    buscarprocessos() {
      this.isLoading = true;

      let data = {
        processo_numero: this.processo_numero,
        processo_vara: this.processo_vara,
        processo_classe: this.processo_classe,
        processo_comitente: this.processo_comitente,
        processo_executado: this.processo_executado,
        processo_exequente: this.processo_exequente,
        processo_referencia: this.processo_referencia,
        processo_local: this.processo_local,
        processo_juiz: this.processo_juiz,
        processo_depositario: this.processo_depositario,
        estado_id: this.estado.id,
        cidade: this.cidade,
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
      };

      console.log("Buscando");
      console.log(data);

      axios
        .post(`/admin/processos/search`, data)
        .then((response) => {
          this.processos = response.data.processos;
          this.total = response.data.total;

          this.pagination(response.data);
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    buscarCidades() {
      this.isLoading = true;

      let data = {
        estado_id: this.estado.id,
      };

      axios
        .post(`/admin/endereco/cidades_por_estado`, data)
        .then((response) => {
          this.cidades = response.data.cidades;

          this.isLoading = false;
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      this.max_page = Math.ceil(length);

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          length = Math.ceil(length);

          if (length - this.pagina_atual >= 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }

          //CASO O CALCULO O MINIMO SEJA IGUAL A PAGINA ATUAL - 1, REDUZIR 10 DA PAGINA ATUAL CASO ELA SEJA MAIOR QUE 10
          if (i == this.pagina_atual - 1 && this.pagina_atual >= 10) {
            i = this.pagina_atual - 10;
          }

          console.log("I = " + i);
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.buscarprocessos();
    },

    deletar(processo) {
      this.processo_selecionado = processo;

      this.$swal
        .fire({
          title: "<h3 style='color:#616060'>Deseja deletar o tipo de processo<b><br/>" + this.processo_selecionado.nome + "</b>? </h3>",
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero deletar!",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              id: this.processo_selecionado.id,
            };

            axios
              .post(`/admin/processo/delete`, data)
              .then((response) => {
                this.showSuccessMessage("processo deletado!");

                window.location.reload();
              })
              .catch((error) => {
                this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                console.log(error.response.data);
              });
          }
        });
    },

    validateFields() {
      if (!this.nome) {
        this.showErrorMessageWithButton("Ops...", "O campo nome é obrigatório!");
      } else {
        this.create();
      }
    },

    update() {
      this.isLoading = true;

      let data = {
        id: this.processo_selecionado.id,
        cadastro_tipo: this.processo_selecionado.cadastro_tipo,
        tipodoc: this.processo_selecionado.tipodoc,
        estado_civil: this.processo_selecionado.estado_civil,
        obrigatorio: this.processo_selecionado.obrigatorio,
      };

      console.log("ATUALIZANDO");
      console.log(data);

      axios
        .post(`/admin/documento_tipo_usuario/update`, data)
        .then((response) => {
          this.showSuccessMessage("Estilo atualizado!");

          window.location.reload();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
  },
};
</script>
